import { Injectable, EventEmitter } from '@angular/core';

import { Mast, Item, Frm, Acc, comboInfo, Std_Doc, Fiscal_Yr, FrmSettingDetail, Class_Subj } from '../dbcontroller/mast';
import { ToastrService } from 'ngx-toastr';
// import { NgxUiLoaderConfig, NgxUiLoaderService } from 'ngx-ui-loader';
import { DatePipe } from '@angular/common';
import { MenuService } from 'src/app/core/menu/menu.service';
// import { stdinfo } from 'src/app/school/student/registration/regstrationclass';
// import { feeinfo } from 'src/app/school/fee/feereceipt/feereceiptclass';
// import { gateentryinfo } from 'src/app/school/gateentry/gateentryform/gateentryclass';
// import { TransactionDetail } from 'src/app/cash/cashregister/cashregister.component';
import { throwError } from 'rxjs/internal/observable/throwError';
import { TabService } from 'src/app/core/admin-layout/tab.service';

@Injectable()

export class AMControllerService {
  gateentrydocs: any[];
  public socket: SocketIOClient.Socket;
  public curr_frmid: number;
  public comp_id: number;
  // config: NgxUiLoaderConfig;


  userinfo: any;

  colors: Mast[] = [];
  sizes: Mast[] = [];
  brands: Mast[] = [];
  units: Mast[] = [];
  classes: Mast[] = [];
  classeWiseFees: any[] = [];
  classeWiseTeachers: Mast[] = [];
  classInterpersonalSkills: Mast[] = [];
  sections: Mast[] = [];
  subjects: Mast[] = [];
  feecate: Mast[] = [];
  itemgroups: Mast[] = [];
  itemsubgroups: Mast[] = [];
  accounts: Acc[] = [];
  accgroups: Mast[] = [];
  doctype: Mast[] = [];
  accsubgroups: Mast[] = [];
  items: any[] = [];
  classsubmast: Class_Subj[] = [];
  classteachermast: Mast[] = [];
  timetables: any[] = [];
  teachers: Mast[] = [];
  categorys: Mast[] = [];
  religions: Mast[] = [];
  languages: Mast[] = [];
  citys: Mast[] = [];
  states: Mast[] = [];
  machines: Mast[] = [];
  feeheads: Mast[] = [];
  gstpers: Mast[] = [];
  currency: Mast[] = [];
  houses: Mast[] = [];
  periods: Mast[] = [];
  // studentslist: stdinfo[] = [];
  studentdocs: Std_Doc[] = [];
  fiscalyears: Fiscal_Yr[] = [];
  frmDetailSetting: FrmSettingDetail[] = [];
  frmInoutCat: Mast[] = [];
  frmSOCat: Mast[] = [];
  registersCatList: any[] = [];
  currfiscalyr: Fiscal_Yr;
  // feedaybooklist: feeinfo[] = [];
  // gateentrylist: gateentryinfo[] = [];

  //payroll Arrays
  emplist: any[] = [];
  salheadlist: any[] = [];
  ////////////////

  fiscals: any[] = [];
  complist: any[] = [];

  formlist: Frm[] = [];
  ErrorCodeWithMessages: comboInfo[] = [];
  paymode: comboInfo[] = [];
  months: comboInfo[] = [];
  currTransReport: any;

  userList: any[] = [];
  activeUserList: Mast[] = [];

  weekdays: string[] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  // updateStdInfo: stdinfo = null;

  // Only for kidley dealer portal
  updateOrdInfo: any = null; // Only for kidley dealer portal
  OrderCategory: any = null; // Only for kidley dealer portal
  // Only for kidley dealer portal

  public tempVal: any;
  public dashboardInfo: Mast;
  public isotplogin: boolean = false;

  TicketSuccessEvent = new EventEmitter<Mast>();
  constructor(private datepipe: DatePipe, private toastr: ToastrService, public menuservice: MenuService, public tabservice: TabService) {
    // this.toastr.setRootViewContainerRef(containerRef);
    this.prepareFormList();

    // this.config = this.uiloader.getDefaultConfig();
  }

  setToasterViewContainer(containerRef) {
    this.toastr.overlayContainer = containerRef;
  }

  showDialogSuccessInfo(messageInfo) {
    this.toastr.clear();
    this.toastr.success(messageInfo, 'Success!', { timeOut: 3000 });
  }

  showDialogFailedInfo(messageInfo) {
    this.toastr.error(messageInfo, 'Oops!');
  }

  // showDialogRetainInfo(messageInfo) {
  //   this.toastr.info(messageInfo, 'click to Dismiss', { dismiss: 'click' });
  // }

  // public getNewAdmissionNo() {
  //   return Math.max.apply(Math, this.studentslist.map(function (o) { return o.stdadmno; }));
  // }
  // public getNewRollNo(clsid: number, secid: number) {
  //   return this.studentslist.filter(x => x.stdclass == clsid && x.stdsec == secid).length > 0 ? Math.max.apply(Math, this.studentslist.filter(x => x.stdclass == clsid && x.stdsec == secid).map(function (o) { return o.stdrollno; })) + 1 : 1;
  // }

  sendRequest(ReqInfo) {
    if (this.socket && !this.socket.connected) {
      this.socket.connect();
    }
    this.socket.compress(true).emit('rqm', JSON.stringify(ReqInfo));
  }

  open() {
    // this.dialogsService
    //   .confirm('Hey Gagan Dialog', 'Are you sure you want to do this?')
    //   .subscribe(res => this.result = res);
  }

  public findAndRemove(array, property, value) {
    array.forEach(function (result, index) {
      if (result[property] === value) {
        //Remove from array
        array.splice(index, 1);
      }
    });
  }

  // Error handling
  errorHandl(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }

  public _Studentfilter(stdlist: any[], value: string): any[] {
    if (value.length <= 1) {
      return null;
    } else {
      if (String(value).includes(" ")) {
        return stdlist.sort(function (a, b) { return a.stdadmno - b.stdadmno }).filter(o => {
          let indexCount = 0;
          for (let key of String(value).trim().split(" ")) {
            if ((key != "" && key != undefined) && (String(o.stdadmno).toLowerCase().includes(key) ||
              String(o.stdname).toLowerCase().includes(key) ||
              String(o.class).toLowerCase().includes(key))) {
              indexCount += 1;
            }
          }

          if (indexCount == String(value).trim().split(" ").length) {
            return true;
          } else {
            return false;
          }
        });
      } else {
        return stdlist.sort(function (a, b) { return a.stdadmno - b.stdadmno }).filter(x => String(x.stdadmno).toLowerCase().includes(String(value)) ||
          String(x.stdname).toLowerCase().includes(String(value)) ||
          String(x.stdclass).toLowerCase().includes(String(value)));
      }
    }
  }

  getCurrentTimeZoneDate(dt: string) {
    if (dt == null) {
      return null;
    } else {
      return this.datepipe.transform(dt, "yyyy-MMM-dd");
    }
  }
  public findAndReplace(array, property, RowID, RowInfo) {
    array.forEach(function (result, index) {
      if (result[property] === RowID) {
        //Remove from array
        array.splice(index, 1);
        array.push(RowInfo);
      }
    });
  }

  public getcurrentDtTime() {
    return new Date();
  }

  public findAndRetrive(array, FindID, GetProperty, value) {
    array.forEach(function (result) {
      if (result[FindID] === value) {
        return result[GetProperty];
      }
    });
  }


  public prepareLocalArray(array, controller) {
    array.forEach(function (arr) {
      if (arr != null) {
        arr.forEach(function (result) {
          if (result["frmid"] === 1) {
            controller.userList.push(result);
          }
          if (result["frmid"] === 2) {
            controller.fiscalyears.push(result);
          }
          if (result["frmid"] === 3) {
            result.dontEmit = false;
            controller.menuservice.menulist.push(result);
          }
          if (result["frmid"] === 3.1) {
            controller.frmDetailSetting.push(result);
          }
          if (result["frmid"] === 9) {
            controller.frmflow.push(result);
          }
          if (result["frmid"] === 10) {
            controller.colors.push(result);
          }
          if (result["frmid"] === 11) {
            controller.sizes.push(result);
          }
          if (result["frmid"] === 12) {
            controller.brands.push(result);
          }
          if (result["frmid"] === 13) {
            controller.units.push(result);
          }
          if (result["frmid"] === 14) {
            controller.classes.push(result);
          }
          if (result["frmid"] === 1401) {
            controller.classeWiseFees.push(result);
          }
          if (result["frmid"] === 1402) {
            controller.classeWiseTeachers.push(result);
          }
          if (result["frmid"] === 15) {
            controller.sections.push(result);
          }
          if (result["frmid"] === 16) {
            controller.subjects.push(result);
          }
          if (result["frmid"] === 17) {
            controller.feecate.push(result);
          }
          if (result["frmid"] === 18) {
            controller.itemgroups.push(result);
          }
          if (result["frmid"] === 19) {
            controller.itemsubgroups.push(result);
          }
          if (result["frmid"] === 20) {
            controller.doctype.push(result);
          }
          if (result["frmid"] === 21) {
            controller.items.push(result);
          }
          if (result["frmid"] === 22) {
            controller.accounts.push(result);
          }
          if (result["frmid"] === 23) {
            controller.accgroups.push(result);
          }
          if (result["frmid"] === 24) {
            controller.accsubgroups.push(result);
          }
          if (result["frmid"] === 25) {
            controller.classsubmast.push(result);
          }
          if (result["frmid"] === 26) {
            controller.classteachermast.push(result);
          }
          if (result["frmid"] === 27) {
            controller.teachers.push(result);
          }
          if (result["frmid"] === 28) {
            controller.categorys.push(result);
          }
          if (result["frmid"] === 29) {
            controller.religions.push(result);
          }
          if (result["frmid"] === 30) {
            controller.languages.push(result);
          }
          if (result["frmid"] === 31) {
            controller.feeheads.push(result);
          }
          if (result["frmid"] === 33) {
            controller.citys.push(result);
          }
          if (result["frmid"] === 34) {
            controller.states.push(result);
          }
          if (result["frmid"] === 35) {
            controller.houses.push(result);
          }
          if (result["frmid"] === 36) {
            controller.fiscals.push(result);
          }
          if (result["frmid"] === 37) {
            controller.complist.push(result);
          }
          if (result["frmid"] === 38) {
            controller.frmInoutCat.push(result);
          }
          if (result["frmid"] === 39) {
            controller.machines.push(result);
          }
          // if (result["frmid"] === 108) {
          //   controller.currTransections.push(result);
          // }
          if (result["frmid"] === 41) {
            controller.emplist.push(result);
          }
          if (result["frmid"] === 42) {
            controller.salheadlist.push(result);
          }
          if (result["frmid"] === 43) {
            controller.classInterpersonalSkills.push(result);
          }
          if (result["frmid"] === 44) {
            controller.periods.push(result);
          }

          if (result["frmid"] === 45) {
            controller.frmSOCat.push(result);
          }
          if (result["frmid"] === 113) {
            controller.timetables.push(result);
          }
          if (Number(result["frmid"]) === 115.1) {
            controller.registersCatList.push(result);
          }

          // if (result["frmid"] === 110) {
          //   controller.classsubmast.push(result);
          // }

          if (result["frmid"] === 101) {
            // let stdrow: any;
            // stdrow = new stdinfo(result.doa, result.id, result.stdname, result.classid, result.section,
            //   result.rollno, result.admno, result.gender, result.category, result.religion,
            //   result.dob, result.fathername, result.aadharno, result.mothername, result.mobile1,
            //   result.mobile2, result.address, result.email, result.bldgrp, result.mothertng,
            //   result.firstlang, result.optlang, result.schconyenc, result.stuckoff, result.fatheredu, result.fatheroccup,
            //   result.motheredu, result.motheroccup, result.sibling1, result.sibling2, result.sibling3, result.house, result.city, result.state, result.sub1, result.sub2, result.sub3, result.sub4, result.sub5, result.sub6, result.sub7,
            //   result.sub8, result.misc1, result.misc1, result.prevsch, result.prevboard, result.passyr, result.marksper, result.prevclssid,
            //   null, 101, controller.userinfo.compid, 1, controller.userinfo.user_id);

            // stdrow.class = controller.getclassname(stdrow.stdclass);
            // stdrow.section = controller.getsectionname(stdrow.stdsec);
            // stdrow.category = controller.getcategoryname(stdrow.stdcat);
            // stdrow.religion = controller.getreligionname(stdrow.stdrelgn);
            // if (stdrow.stdhouse != undefined || stdrow.stdhouse != null) {
            //   stdrow.house = controller.gethousename(stdrow.stdhouse);
            // } else {
            //   stdrow.house = "N.A.";
            // }

            // stdrow.gender = stdrow.stdgender == 1 ? 'Male' : 'Female';
            // controller.studentslist.push(stdrow);
          }
          if (result["frmid"] == 101001) {
            controller.studentdocs.push(result);
          }
          if (result["frmid"] == 104) {
            // controller.gateentrylist.push(new gateentryinfo(result.srno, result.name, result.address, result.tomeet,
            //   result.purpose, result.mobile, result.type, result.stdid, result.remarks, result.frmid, result.compid, result.sessid,
            //   0, result.userid, result.ctime));
          }

          // if (result["formid"] === 201) {
          //   controller.dashboardInfo = result;
          // }

          if (result instanceof Array) {
            controller.activeUserList = Array.from(result);
          }
        }
        );
      }

    });
  }
  public getcolname(val) {
    if (val == null || val == 0) {
      return "";
    } else {
      return this.colors.find(x => x.id == val).str1;
    }
  }
  public getinterskillname(val) {
    if (val == null || val == 0) {
      return "";
    } else {
      return this.classInterpersonalSkills.find(x => x.id == val).str1;
    }
  }
  public getsizename(val) {
    if (val == null || val == 0) {
      return "";
    } else {
      return this.sizes.find(x => x.id == val).str1;
    }
  }
  public getbrandname(val) {
    if (val == null || val == 0) {
      return "";
    } else {
      return this.brands.find(x => x.id == val).str1;
    }
  }
  public getmachinename(val) {
    if (val == null || val == 0) {
      return '';
    } else {
      return this.machines.find(x => x.id == val).str1;
    }
  }
  public getunitname(val) {
    if (val == null || val == 0) {
      return '';
    } else {
      return this.units.find(x => x.id == val).str1;
    }
  }
  public getclassname(val) {
    if (val == null || val == 0) {
      return '';
    } else {
      return this.classes.find(x => x.id == val).str1;
    }
  }
  public getsectionname(val) {
    if (val == null || val == 0) {
      return '';
    } else {
      return this.sections.find(x => x.id == val).str1;
    }
  }
  public getsubjectname(val) {
    if (val == null) {
      return '';
    } else {
      return this.subjects.find(x => x.id == val).str1;
    }
  }
  public getfeecatename(val) {
    if (val == null || val == 0) {
      return '';
    } else {
      return this.feecate.find(x => x.id == val).str1;
    }
  }
  public getteachername(val) {
    if (val == null || val == 0) {
      return '';
    } else {
      return this.teachers.find(x => x.id == val).str1;
    }
  }
  public getgroupname(val) {
    if (val == null || val == 0) {
      return '';
    } else {
      return this.itemgroups.find(x => x.id == val).str1;
    }
  }
  public getsubgrpname(val) {
    if (val == null || val == 0) {
      return '';
    } else {
      return this.itemsubgroups.find(x => x.id == val).str1;
    }

  }
  public getdoctypename(val) {
    if (val == null || val == 0) {
      return '';
    } else {
      return this.doctype.find(x => x.id == val).str1;
    }
  }
  public getcategoryname(val) {
    if (val == null || val == 0) {
      return '';
    } else {
      return this.categorys.find(x => x.id == val).str1;
    }
  }
  public getreligionname(val) {
    if (val == null || val == 0) {
      return '';
    } else {
      return this.religions.find(x => x.id == val).str1;
    }
  }
  public getlanguagename(val) {
    if (val == null || val == 0) {
      return null;
    } else {
      return this.languages.find(x => x.id == val).str1;
    }
  }
  public getcityname(val) {
    if (val == null || val == 0) {
      return '';
    } else {
      return this.citys.find(x => x.id == val).str1;
    }
  }
  public getpaymentmodename(val) {
    if (val == null || val == 0) {
      return '';
    } else {
      return this.paymode.find(x => x.id == val).str1;
    }
  }
  public getstatename(val) {
    if (val == null || val == 0) {
      return '';
    } else {
      return this.states.find(x => x.id == val).str1;
    }
  }
  public getperiodname(val) {
    if (val == null || val == 0) {
      return '';
    } else {
      return this.periods.find(x => x.id == val).str1;
    }
  }
  public getperiodwithinoutname(val) {
    if (val == null || val == 0) {
      return '';
    } else {
      val = this.periods.find(x => x.id == val);
      return val.str1 + " (" + val.str2 + " - " + val.str3 + ")";
    }
  }
  public gethousename(val) {
    if (val == null || val == 0) {
      return null;
    } else {
      return this.houses.find(x => x.id == val).str1;
    }
  }
  public getfeeheadname(val) {
    if (val == null || val == 0) {
      return '';
    } else {
      return this.feeheads.find(x => x.id == val).str1;
    }
  }
  public getitemname(val) {
    if (val == null || val == 0) {
      return '';
    } else {
      let value = this.items.find(x => x.id == val);
      return value != undefined ? value.itemname : '';
    }
  }
  public getitemNameCateLocalItemIDWise(cate, localitemid) {
    if (localitemid == null || localitemid == 0) {
      return '';
    } else {
      let value = this.items.find(x => x.localitemid == localitemid && x.groupid == cate);
      return value != undefined ? value.itemname : '';
    }
  }
  public getaccname(val) {
    if (val == null || val == 0) {
      return '';
    } else {
      return this.accounts.find(x => x.id == val).acname;
    }
  }
  public getaccgrpname(val) {
    if (val == null || val == 0) {
      return '';
    } else {
      return this.accgroups.find(x => x.id == val).str1;
    }
  }
  public getaccsubgrpname(val) {
    if (val == null || val == 0) {
      return '';
    } else {
      return this.accsubgroups.find(x => x.id == val).str1;
    }
  }
  public getUserName(val) {
    if (val == null || val == 0) {
      return '';
    } else {
      return this.userList.find(x => x.user_id == val).actual_name;
    }
  }
  public setZeroToBlank(val) {
    if (val == null || val == 0) {
      return '';
    } else {
      return val;
    }
  }
  public getFrmName(val) {
    if (val == null || val == 0) {
      return null;
    } else {
      return this.formlist.find(x => x.id == val).title;
    }
  }

  prepareFormList() {
    // this.classsubmast.push({id: 1,classid: 90,sub1: 125,sub2: 126,sub3: 127,
    //   sub4: 128,sub5: 138,sub6: 148,sub7: 0,sub8: 0,sub9: 0,
    //   sub10: 0,misc1: 132,misc2: 133,misc3: 0,misc4: 0,
    //   attterm1: 217,attterm2: 362,markcate: 1,ts: null, ts2: null, us: null, frmid: 25, compid: 51,actionType: 0, uid: 0});
    this.formlist.push({ id: 10, description: "", title: "Color" });
    this.formlist.push({ id: 11, description: "", title: "Size" });
    this.formlist.push({ id: 12, description: "", title: "Brand" });
    this.formlist.push({ id: 13, description: "", title: "Unit" });
    this.formlist.push({ id: 14, description: "", title: "Class" });
    this.formlist.push({ id: 15, description: "", title: "Section" });
    this.formlist.push({ id: 16, description: "", title: "Subjects" });
    this.formlist.push({ id: 17, description: "", title: "Fee Cate" });
    this.formlist.push({ id: 18, description: "", title: "Group" });
    this.formlist.push({ id: 19, description: "", title: "SubGroup" });
    this.formlist.push({ id: 20, description: "", title: "Document Type" });
    this.formlist.push({ id: 21, description: "", title: "Item" });
    this.formlist.push({ id: 22, description: "", title: "Account" });
    this.formlist.push({ id: 23, description: "", title: "Acc Group" });
    this.formlist.push({ id: 24, description: "", title: "Acc Sub-Group" });
    this.formlist.push({ id: 25, description: "", title: "Class Subject Master" });
    this.formlist.push({ id: 26, description: "", title: "Class Teacher Master" });
    this.formlist.push({ id: 27, description: "", title: "Teacher" });
    this.formlist.push({ id: 28, description: "", title: "Category" });
    this.formlist.push({ id: 29, description: "", title: "Religion" });
    this.formlist.push({ id: 30, description: "", title: "Language" });
    this.formlist.push({ id: 31, description: "", title: "Fee Head" });
    this.formlist.push({ id: 32, description: "", title: "Class Fee Structure" });
    this.formlist.push({ id: 33, description: "", title: "City" });
    this.formlist.push({ id: 34, description: "", title: "State" });
    this.formlist.push({ id: 35, description: "", title: "House" });
    this.formlist.push({ id: 38, description: "", title: "Inout Category" });
    this.formlist.push({ id: 39, description: "", title: "Machine" });
    this.formlist.push({ id: 44, description: "", title: "Periods" });
    this.formlist.push({ id: 103, description: "", title: "In" });
    this.formlist.push({ id: 107, description: "", title: "Out" });
    this.formlist.push({ id: 105, description: "", title: "IST" });
    this.formlist.push({ id: 106, description: "", title: "Opening" });
    this.formlist.push({ id: 113, description: "", title: "Time Table" });
    this.formlist.push({ id: 115, description: "", title: "Sale Order" });
    this.formlist.push({ id: 0, description: "", title: "Opening" });

    this.ErrorCodeWithMessages.push({ id: 102, str1: "Duplicate Value", num1: 0 });
    this.ErrorCodeWithMessages.push({ id: 103, str1: "Already In Use Cant Delete", num1: 0 });
    this.ErrorCodeWithMessages.push({ id: 101, str1: "Unknow Error Contact Admin", num1: 0 });
    this.ErrorCodeWithMessages.push({ id: 104, str1: "Unknow Error Contact Admin", num1: 0 });
    this.ErrorCodeWithMessages.push({ id: 500, str1: "Action Failed Contact Admin", num1: 0 });
    this.ErrorCodeWithMessages.push({ id: 110, str1: "Action Failed Contact Admin", num1: 0 });

    this.paymode.push({ id: 1, str1: "Cash", num1: 0 });
    this.paymode.push({ id: 2, str1: "Cheque", num1: 0 });
    this.paymode.push({ id: 3, str1: "Online", num1: 0 });
    this.paymode.push({ id: 4, str1: "Card", num1: 0 });

    this.months.push({ id: 1, str1: "Jan", num1: 10 });
    this.months.push({ id: 2, str1: "Feb", num1: 11 });
    this.months.push({ id: 3, str1: "Mar", num1: 12 });
    this.months.push({ id: 4, str1: "Apr", num1: 1 });
    this.months.push({ id: 5, str1: "May", num1: 2 });
    this.months.push({ id: 6, str1: "Jun", num1: 3 });
    this.months.push({ id: 7, str1: "Jul", num1: 4 });
    this.months.push({ id: 8, str1: "Aug", num1: 5 });
    this.months.push({ id: 9, str1: "Sep", num1: 6 });
    this.months.push({ id: 10, str1: "Oct", num1: 7 });
    this.months.push({ id: 11, str1: "Nov", num1: 8 });
    this.months.push({ id: 12, str1: "Dec", num1: 9 });


  }

  getMastersArrayByFormID(formid: number) {
    if (formid == 10) {
      return this.colors.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 11) {
      return this.sizes.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 12) {
      return this.brands.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 13) {
      return this.units.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 14) {
      return this.classes.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 14.1) {
      return this.classeWiseFees.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 15) {
      return this.sections.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 16) {
      return this.subjects.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 17) {
      return this.feecate.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 18) {
      return this.itemgroups.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 19) {
      return this.itemsubgroups.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 20) {
      return this.doctype.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 23) {
      return this.accgroups.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 24) {
      return this.accsubgroups.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 26) {
      return this.classteachermast.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 27) {
      return this.teachers.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 28) {
      return this.categorys.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 29) {
      return this.religions.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 30) {
      return this.languages.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 31) {
      return this.feeheads.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 33) {
      return this.citys.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 34) {
      return this.states.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 35) {
      return this.houses.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 38) {
      return this.frmInoutCat.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 45) {
      return this.frmSOCat.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 44) {
      return this.periods.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 113) {
      return this.timetables.sort(function (a, b) { return b.id - a.id });
    } else if (formid == 46) {
      return this.registersCatList.sort(function (a, b) { return b.id - a.id });
    }
  }
  getMasterInfoByFormIDAndID(formid: number, id: number) {
    if (formid == 10) {
      return this.colors.find(x => x.id == Number(id));
    } else if (formid == 11) {
      return this.sizes.find(x => x.id == Number(id));
    } else if (formid == 12) {
      return this.brands.find(x => x.id == Number(id));
    } else if (formid == 13) {
      return this.units.find(x => x.id == Number(id));
    } else if (formid == 14) {
      return this.classes.find(x => x.id == Number(id));
    } else if (formid == 15) {
      return this.sections.find(x => x.id == Number(id));
    } else if (formid == 16) {
      return this.subjects.find(x => x.id == Number(id));
    } else if (formid == 17) {
      return this.feecate.find(x => x.id == Number(id));
    } else if (formid == 18) {
      return this.itemgroups.find(x => x.id == Number(id));
    } else if (formid == 19) {
      return this.itemsubgroups.find(x => x.id == Number(id));
    } else if (formid == 20) {
      return this.doctype.find(x => x.id == Number(id));
    } else if (formid == 21) {
      return this.items.find(x => x.id == Number(id));
    } else if (formid == 22) {
      return this.accounts.find(x => x.id == Number(id));
    } else if (formid == 23) {
      return this.accgroups.find(x => x.id == Number(id));
    } else if (formid == 24) {
      return this.accsubgroups.find(x => x.id == Number(id));
    } else if (formid == 25) {
      return this.classsubmast.find(x => x.id == Number(id));
    } else if (formid == 26) {
      return this.classteachermast.find(x => x.id == Number(id));
    } else if (formid == 27) {
      return this.teachers.find(x => x.id == Number(id));
    } else if (formid == 28) {
      return this.categorys.find(x => x.id == Number(id));
    } else if (formid == 29) {
      return this.religions.find(x => x.id == Number(id));
    } else if (formid == 30) {
      return this.languages.find(x => x.id == Number(id));
    } else if (formid == 31) {
      return this.feeheads.find(x => x.id == Number(id));
    } else if (formid == 33) {
      return this.citys.find(x => x.id == Number(id));
    } else if (formid == 34) {
      return this.states.find(x => x.id == Number(id));
    } else if (formid == 35) {
      return this.houses.find(x => x.id == Number(id));
    } else if (formid == 38) {
      return this.frmInoutCat.find(x => x.id == Number(id));
    } else if (formid == 45) {
      return this.frmSOCat.find(x => x.id == Number(id));
    } else if (formid == 44) {
      return this.periods.find(x => x.id == Number(id));
    } else if (formid == 113) {
      return this.timetables.find(x => x.id == Number(id));
    }
  }


  // getCrsSubGrpName(val) {
  //   if (val === undefined) {
  //     return "";
  //   } else {
  //     return this.crssubgrps.find(x => x.id === Number(this.courses.find(x => x.id === Number(val)).num2)).str1;
  //   }
  // }

  public NumInWords(number) {
    const first = ['', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ', 'Ten ', 'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ', 'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen '];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const mad = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];
    let word = '';

    for (let i = 0; i < mad.length; i++) {
      let tempNumber = number % (100 * Math.pow(1000, i));
      if (Math.floor(tempNumber / Math.pow(1000, i)) !== 0) {
        if (Math.floor(tempNumber / Math.pow(1000, i)) < 20) {
          word = first[Math.floor(tempNumber / Math.pow(1000, i))] + mad[i] + ' ' + word;
        } else {
          word = tens[Math.floor(tempNumber / (10 * Math.pow(1000, i)))] + '-' + first[Math.floor(tempNumber / Math.pow(1000, i)) % 10] + mad[i] + ' ' + word;
        }
      }

      tempNumber = number % (Math.pow(1000, i + 1));
      if (Math.floor(tempNumber / (100 * Math.pow(1000, i))) !== 0) word = first[Math.floor(tempNumber / (100 * Math.pow(1000, i)))] + 'hunderd ' + word;
    }
    return word;
  }

  public groupArrayOfObjects(list, key) {
    return list.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

  public removeDulicatesFromArray(data) {
    return data.reduce((acc, curr) => acc.includes(curr) ? acc : [...acc, curr], []);
  }



  getYearMonthDiffString(diffDays: number) {
    var months = Math.floor(diffDays / 31);
    var years = Math.floor(months / 12);

    return (years > 0 ? years + ' Years ' : "") + "  " + (months > 0 ? months - (years * 12) + ' Month ' : "") + "  " + (diffDays > 0 ? diffDays - (months * 31) + ' Days ' : "");
  }

}